import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchMtrStructSubList(listQuery, requestConfig = {}) {
  const { data: raw } = await request.get('/mtr-struct-sub', {
    params: listQueryToApiParams(listQuery),
    ...requestConfig,
  });
  return parseVer4ListResponse(raw);
}
